<template>
  <BoxUsersTable />
</template>

<script lang="ts" setup>
import { useAuthorizationContext } from '@/composables/deepadmin/use-authorization-context.ts'
import usePageAccess from '@/composables/deepadmin/use-page-access.ts'
import BoxUsersTable from '@/components/deepbox/box/BoxUsersTable.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.deepbox.box.users',
  },
})

const { permissions } = useAuthorizationContext()

usePageAccess(computed(() => !permissions.canViewBoxes))
</script>
